import { motion } from 'framer-motion';
import { H5, Body } from '../ui/Typography';

export default function MetricsBanner() {
  const metrics = [
    { label: 'Total Real Estate AUM', value: '$500K+' },
    { label: 'Number of Properties', value: '4' },
    { label: 'Average Yield', value: '11.66%' }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
      {metrics.map((metric, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
        >
          <div className="bg-white rounded-lg shadow-lg p-6">
            <H5 className="text-gray-900 mb-2">
              {metric.label}
            </H5>
            <Body className="font-bold text-[32px] leading-[40px] text-primary">
              {metric.value}
            </Body>
          </div>
        </motion.div>
      ))}
    </div>
  );
}